import React from "react";

export default function Google_Social() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Google_Social</h2>
      <p>Route: /icons/google/social</p>
    </div>
  );
}
